export default function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 if (ctx.prefix || ctx.suffix) { ;
__p += '\n<div class="' +
((__t = (ctx.ofPrefix)) == null ? '' : __t) +
'input-container">\n';
 } ;
__p += '\n';
 if (ctx.prefix) { ;
__p += '\n<span class="' +
((__t = (ctx.ofPrefix)) == null ? '' : __t) +
'input-container__affix ' +
((__t = (ctx.ofPrefix)) == null ? '' : __t) +
'input-container__affix--prefix" ref="prefix">\n    ';
 if(ctx.prefix instanceof HTMLElement){ ;
__p += '\n      ' +
((__t = ( ctx.t(ctx.prefix.outerHTML) )) == null ? '' : __t) +
'\n    ';
 } else{ ;
__p += '\n      ' +
((__t = ( ctx.t(ctx.prefix) )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n</span>\n';
 } ;
__p += '\n<' +
((__t = (ctx.input.type)) == null ? '' : __t) +
'\n  ref="' +
((__t = (ctx.input.ref ? ctx.input.ref : 'input')) == null ? '' : __t) +
'"\n  ';
 for (var attr in ctx.input.attr) { ;
__p += '\n  ' +
((__t = (attr)) == null ? '' : __t) +
'="' +
((__t = (ctx.input.attr[attr])) == null ? '' : __t) +
'"\n  ';
 } ;
__p += '\n  id="' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'"\n  ';
 if (ctx.suffix) { ;
__p += '\n    aria-labelledby="label-' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
' ' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
' suffix-' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'"\n  ';
 } ;
__p += '\n>' +
((__t = (ctx.input.content)) == null ? '' : __t) +
'</' +
((__t = (ctx.input.type)) == null ? '' : __t) +
'>\n';
 if (ctx.component.showCharCount) { ;
__p += '\n<span class="charcount" ref="charcount"></span>\n';
 } ;
__p += '\n';
 if (ctx.component.showWordCount) { ;
__p += '\n<span class="wordcount" ref="wordcount"></span>\n';
 } ;
__p += '\n';
 if (ctx.suffix) { ;
__p += '\n<span class="' +
((__t = (ctx.ofPrefix)) == null ? '' : __t) +
'input-container__affix ' +
((__t = (ctx.ofPrefix)) == null ? '' : __t) +
'input-container__affix--suffix" ref="suffix" id="suffix-' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'">\n    ';
 if(ctx.suffix instanceof HTMLElement){ ;
__p += '\n      ' +
((__t = ( ctx.t(ctx.suffix.outerHTML) )) == null ? '' : __t) +
'\n    ';
 } else{ ;
__p += '\n      ' +
((__t = ( ctx.t(ctx.suffix) )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n</span>\n';
 } ;
__p += '\n';
 if (ctx.prefix || ctx.suffix) { ;
__p += '\n</div>\n';
 } ;
__p += '\n\n';
 if (ctx.component?.openForms?.requireVerification) { ;
__p += '\n\n<div class="utrecht-alert utrecht-alert--warning">\n  <div class="utrecht-alert__icon">\n    <i class="fa fas fa-exclamation-triangle"></i>\n  </div>\n  <div class="utrecht-alert__message">\n    ' +
((__t = (ctx.t('You must verify this email address to continue.'))) == null ? '' : __t) +
'\n  </div>\n</div>\n\n<button ref="verifyButton" class="utrecht-button utrecht-button--primary-action">\n  ' +
((__t = (ctx.t('Verify'))) == null ? '' : __t) +
'\n</button>\n';
 } ;
__p += '\n';
return __p
}